import React from 'react';
import { FiSlash } from 'react-icons/fi';

import { Badge } from 'components/Badge';

/**
 * @typedef {Object} PurchasedListBadgeProps
 * @property {string?} className
 */

/**
 * Badge indicating that a contact is from a purchased list
 * and email sending is not supported
 *
 * @param {PurchasedListBadgeProps} props
 */
export function PurchasedListBadge({ className }) {
    return (
        <Badge className={className} type="danger">
            <FiSlash /> Purchased List
        </Badge>
    );
}
